import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage, buildSuccessMessage} from '../../common/util/errorUtils';

export const clearVehicle = () => {
  return {
    'type': ActionTypes.CLEAR_VEHICLE_CERTIFICATION,
  };
};

export const clearImages = () => {
  return {
    'type': ActionTypes.CLEAR_IMAGES_VEHICLE_CERTIFICATION,
  };
};

export const fetchImagesCertificate = (idRequest) =>
  apiActionCreator({
    'endpoint': `/veh-cert/${idRequest}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_IMAGE_VEHICLE_CERTIFICATION,
      ActionTypes.FETCHED_IMAGE_VEHICLE_CERTIFICATION,
      [ActionTypes.FETCHED_IMAGE_VEHICLE_CERTIFICATION_FAILED, (error) => buildErrorMessage(error)],
    ],
    'microservice': 'form',
    'method': 'GET',
  });

export const getVehicleByChasis = (chasis, fetch = true, type) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/certification/chasis/${chasis}?type=${type}`,
      'authenticated': true,
      'types': [
        ActionTypes.FETCHING_VEHICLE_CERTIFICATION,
        [
          (response) => {
            if (response.data.vehCertId && fetch) {
              dispatch(clearVehicle());
              dispatch(clearImages());
              dispatch(fetchImagesCertificate(response.data.vehCertId));
            }
            return {
              'type': ActionTypes.FETCHED_VEHICLE_CERTIFICATION,
            };
          },
        ],
        [ActionTypes.FETCHED_VEHICLE_CERTIFICATION_FAILED, (error) => buildErrorMessage(error)],
      ],
      'microservice': 'part',
      'method': 'GET',
    })
  );
};

export const saveImagesCertificate = (formData, id) =>
  apiActionCreator({
    'endpoint': `/veh-cert/${id}`,
    'authenticated': true,
    'types': [
      ActionTypes.ADDING_IMAGE_VEHICLE_CERTIFICATION,
      [
        {
          'type': ActionTypes.ADDED_IMAGE_VEHICLE_CERTIFICATION,
        },
      ],
      [ActionTypes.ADDED_IMAGE_VEHICLE_CERTIFICATION_FAILED, (error) => buildErrorMessage(error)],
    ],
    'microservice': 'form',
    'method': 'POST',
    'data': formData,
  });

// eslint-disable-next-line max-params
export const addSaveRequestCertification = (data, chasis, formData, typeForm) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': '/certification/vehCertificationRegister',
      'authenticated': true,
      'types': [
        ActionTypes.ADDING_VEHICLE_CERTIFICATION,
        [
          (response) => {
            dispatch(saveImagesCertificate(formData, response.data.id));
            dispatch(getVehicleByChasis(chasis, false, typeForm));

            return {
              'type': ActionTypes.ADDED_VEHICLE_CERTIFICATION,
              'payload': data,
            };
          },
          (response) => buildSuccessMessage(response, 'Informacion agregada'),
        ],
        [ActionTypes.ADDED_VEHICLE_CERTIFICATION_FAILED, (error) => buildErrorMessage(error)],
      ],
      'microservice': 'part',
      'contentType': 'application/json',
      'method': 'POST',
      'data': data,
    })
  );
};
